import { NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { TopComponent } from "../top/top.component";


@Component({
  selector: 'app-main-top',
  templateUrl: './main-top.component.html',
  styleUrls: ['./main-top.component.scss'],
  standalone: true,
  imports: [NgIf, TopComponent]
})
export class MainTopComponent implements OnInit, OnDestroy {


  constructor() { }

  ngOnInit() {

  }

  ngOnDestroy() {

  }
}
